export default "/images/vendor/flag-icons/flags/1x1/bt.svg?4ded667616cee76fc78c31237e15d65a";